interface InputProps {
  label: string;
  id: string;
  type?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  error?: string;
  'data-testid'?: string;
}

export function Input({
  label,
  id,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  error,
  'data-testid': testId,
}: InputProps) {
  return (
    <div className="flex flex-col gap-1.5 min-w-0">
      <label htmlFor={id} className="field-label block">
        {label}
        {required && <span className="text-[var(--color-accent)] ml-1">*</span>}
      </label>
      <input
        id={id}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        data-testid={testId}
        className="bg-[var(--color-elevated)] rounded-md text-body-md text-[var(--color-text-primary)] placeholder:text-[var(--color-text-muted)] px-3 py-2.5 w-full min-w-0 box-border focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] focus:ring-offset-0"
      />
      {error && <p className="text-body-xs text-[var(--color-accent)]">{error}</p>}
    </div>
  );
}
